// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__30R37","productName":"Table_productName__3tWhs"};